/**
 * @fileoverview GET handler for the "/companies/:company_id/free_trial/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdFreeTrialDevelopersDeveloperId } from "./constants";
import type { FreeTrialDeveloperResult } from "./types";

export const getFreeTrialDeveloper = reactQueryFetcherAdapter(
  companiesCompanyIdFreeTrialDevelopersDeveloperId,
  (signal: AbortSignal, companyId: string, developerId: string): Promise<FreeTrialDeveloperResult> => {
    return fetch(`/companies/${companyId}/free_trial/developers/${developerId}`, "GET", {}, { signal });
  }
);
